"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("circle", {
  cx: "14",
  cy: "10",
  r: "1.5"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "14",
  cy: "18",
  r: "1"
}, "1"), /*#__PURE__*/_jsx("circle", {
  cx: "14",
  cy: "14",
  r: "1.5"
}, "2"), /*#__PURE__*/_jsx("circle", {
  cx: "14",
  cy: "6",
  r: "1"
}, "3"), /*#__PURE__*/_jsx("path", {
  d: "M3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5M14.5 3c0-.28-.22-.5-.5-.5s-.5.22-.5.5.22.5.5.5.5-.22.5-.5M21 14.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5"
}, "4"), /*#__PURE__*/_jsx("circle", {
  cx: "18",
  cy: "18",
  r: "1"
}, "5"), /*#__PURE__*/_jsx("path", {
  d: "M13.5 21c0 .28.22.5.5.5s.5-.22.5-.5-.22-.5-.5-.5-.5.22-.5.5M21 10.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5"
}, "6"), /*#__PURE__*/_jsx("circle", {
  cx: "18",
  cy: "14",
  r: "1"
}, "7"), /*#__PURE__*/_jsx("circle", {
  cx: "18",
  cy: "6",
  r: "1"
}, "8"), /*#__PURE__*/_jsx("circle", {
  cx: "6",
  cy: "18",
  r: "1"
}, "9"), /*#__PURE__*/_jsx("circle", {
  cx: "6",
  cy: "14",
  r: "1"
}, "10"), /*#__PURE__*/_jsx("path", {
  d: "M3.5 14c0-.28-.22-.5-.5-.5s-.5.22-.5.5.22.5.5.5.5-.22.5-.5"
}, "11"), /*#__PURE__*/_jsx("circle", {
  cx: "10",
  cy: "6",
  r: "1"
}, "12"), /*#__PURE__*/_jsx("circle", {
  cx: "6",
  cy: "10",
  r: "1"
}, "13"), /*#__PURE__*/_jsx("circle", {
  cx: "6",
  cy: "6",
  r: "1"
}, "14"), /*#__PURE__*/_jsx("path", {
  d: "M9.5 21c0 .28.22.5.5.5s.5-.22.5-.5-.22-.5-.5-.5-.5.22-.5.5"
}, "15"), /*#__PURE__*/_jsx("circle", {
  cx: "10",
  cy: "18",
  r: "1"
}, "16"), /*#__PURE__*/_jsx("path", {
  d: "M10.5 3c0-.28-.22-.5-.5-.5s-.5.22-.5.5.22.5.5.5.5-.22.5-.5"
}, "17"), /*#__PURE__*/_jsx("circle", {
  cx: "10",
  cy: "14",
  r: "1.5"
}, "18"), /*#__PURE__*/_jsx("circle", {
  cx: "10",
  cy: "10",
  r: "1.5"
}, "19"), /*#__PURE__*/_jsx("circle", {
  cx: "18",
  cy: "10",
  r: "1"
}, "20")], 'BlurOnTwoTone');